<template>

<img :src="require(`../../../assets/images/${name}`)">

</template>

<script>
export default {
  name: 'Qimage',
  props: {
    name: String
  }
}
</script>

<style lang="scss" scoped>
</style>
